import React from 'react';
import {connect} from 'react-redux';

// Components
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import YourMessageItem from './YourMessageItem';
import Anchor from 'Components/common/Anchor';
import util from 'Utils/commonUtil';

// Actions
import {
    getYourMassageList,
    updateYourMessageTabActive,
    updateYourMassageList,
} from 'Actions/host';
import {
    setFromHostReplayPage,
    updateTaskMessageListPageNum,
    setFromTaskDetailToMessageListPage,
} from 'Actions/taskManagement';
import {T} from 'Actions/translate';

class YourMessage extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };

    state = {
        searchValue: '',
        listLoaded: true,
        tabList: [
            {index: 0, text: T('your_message_order_message'), tabFlag: 1},
            {index: 1, text: T('your_message_task_message'), tabFlag: 2},
            {index: 2, text: T('your_message_system_message'), tabFlag: 3},
        ],
        messageTabActive: 0,
    };

    componentWillMount() {
        if (!this.props.fromTaskDetailToMessageListPageFlag) {
            this.props.updateTaskMessageListPageNum({$set: 0});
            this.getList(true);
            window.scrollTo(0, 0);
        } else {
            this.setState({messageTabActive: 1}, () => {
                this.props.setFromTaskDetailToMessageListPage({$set: false});
                this.pager.page = this.props.currentTaskMessageListPageNum;

                if (this.props.currentTaskMessageListPageNum === 0) {
                    this.getList(true);
                }
            });
        }
    }

    handleChangeTab(item) {
        this.props.updateYourMessageTabActive({$set: item.index});
        this.props.updateYourMassageList([]);
        this.setState({messageTabActive: item.index}, () => {
            this.pager.page = 0;
            this.pager.total = 0;
            this.pager.pageTotal = 9999999999999999999999999;
            this.getList(true);
        });
    }

    getMessageType = (messageTabActive) => {
        let messageType = 'Admin';
        if (messageTabActive === 0) {
            messageType = 'Admin';
        } else if (messageTabActive === 1) {
            messageType = 'TASK';
        } else if (messageTabActive === 2) {
            messageType = 'System';
        }

        return messageType;
    };

    getList = (reload, isMoreFlag) => {
        this.props.setFromHostReplayPage({$set: false});
        this.props.setFromTaskDetailToMessageListPage({$set: false});
        if (this.pager.page >= this.pager.pageTotal) return;
        const {searchValue, messageTabActive} = this.state;
        this.setState({listLoaded: false});
        this.props
            .getYourMassageList({
                messageKey: searchValue.trim(),
                messageMode: messageTabActive === 1 ? 'TASK' : 'ORDER,F1_ORDER',
                pageNum: reload ? 1 : this.pager.page + 1,
                pageSize: this.pager.length,
                messageFrom: messageTabActive === 2 ? 'System' : 'Admin',
            })
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    markRaad = () => {
        const {searchValue, messageTabActive} = this.state;
        this.setState({listLoaded: false});
        this.props
            .getYourMassageList({
                messageKey: searchValue.trim(),
                messageMode: messageTabActive === 1 ? 'TASK' : 'ORDER,F1_ORDER',
                pageNum: 1,
                pageSize: this.pager.length,
                messageFrom: messageTabActive === 2 ? 'System' : 'Admin',
            })
            .then((res) => {
                this.pager.page = res.data.length > 0 ? res.pageNum : 0;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    goBack = () => this.props.history.push('/userCenter');

    //顶部搜索框
    changeSearchInput = (title, value) => {
        this.setState({
            searchValue: value,
        });
    };

    search = () => {
        this.props.updateTaskMessageListPageNum({$set: 0});
        this.props.updateYourMassageList([]);
        this.markRaad();
    };

    chooseItem = (item) => {
        if (item.messageMode === 'TASK') {
            this.props.updateTaskMessageListPageNum({
                $set: this.pager.page,
            });
            this.props.history.push(`/host/taskDetails/`, {
                tabFlag: 3,
                taskLogId: item.messageKey,
                fromTaskMessageFlag: true,
            });
        } else {
            return false;
        }
    };

    render() {
        const {listLoaded, searchValue, tabList, messageTabActive} = this.state;
        const {localData, yourMassageList} = this.props;

        return (
            <div className="your-message-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="your-message-list-header">
                        <h3 className="header-title">
                            {T('your_message_list')}
                        </h3>
                        <SearchInput
                            title="queryKey"
                            value={searchValue}
                            // options={{ hideSearchBtn: true }}
                            onChange={this.changeSearchInput}
                            search={this.search}
                            placeholder={T(
                                messageTabActive === 1
                                    ? 'task_details_number'
                                    : 'order_eone_number',
                            )}></SearchInput>
                    </div>
                    <div className="tab-header your-message-tab-header">
                        {tabList.map((item, index) => {
                            return (
                                <Anchor
                                    key={item.index}
                                    id={'f1Order' + item.index}
                                    className={util.getClassName({
                                        'tab-item': true,
                                        active: index === messageTabActive,
                                    })}
                                    onClickOfSingleTap={() => {
                                        this.handleChangeTab(item);
                                    }}>
                                    {item.text}
                                </Anchor>
                            );
                        })}
                    </div>
                </Header>
                <ScrollWrapper
                    listLoaded={listLoaded}
                    showAbyss={this.pager.page >= this.pager.pageTotal}
                    showLoadingMore={!listLoaded}
                    getMoreData={() => {
                        this.getList(false);
                    }}>
                    <ul className="your-message-list">
                        {yourMassageList && yourMassageList.length > 0
                            ? yourMassageList.map((item, index) => (
                                  <li
                                      key={index}
                                      className="internal-transfer-item">
                                      <YourMessageItem
                                          item={item}
                                          userId={localData.id}
                                          markRaad={this.markRaad}
                                          chooseItem={() =>
                                              this.chooseItem(item)
                                          }
                                      />
                                  </li>
                              ))
                            : null}
                    </ul>
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData, taskManagement} = state;
    return {
        localData,
        yourMassageList: host.yourMassageList,
        messageTabActive: host.messageTabActive,
        fromHostReplayPage: taskManagement.fromHostReplayPage,
        fromTaskDetailToMessageListPageFlag:
            taskManagement.fromTaskDetailToMessageListPageFlag,
        currentTaskMessageListPageNum:
            taskManagement.currentTaskMessageListPageNum,
    };
};

const mapDispatchToProps = {
    getYourMassageList,
    updateYourMessageTabActive,
    updateYourMassageList,
    setFromHostReplayPage,
    updateTaskMessageListPageNum,
    setFromTaskDetailToMessageListPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(YourMessage);
